import CatalystPage from './CatalystPage';
export default CatalystPage;
